import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";

import Header from "../headers/light.js";
import logo from "../../images/logo-full.png";

import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const LeftColumn = tw.div`relative lg:w-8/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-end`;

const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg`;


// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;


export default () => {
  return (
    <>
      <Header/>
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>
            A <span tw="text-primary-500">one-tap</span> solution to the infodemic.
            </Heading>
            <Paragraph>
            The spread of false facts regarding COVID19 has made the pandemic increasingly difficult to handle as the public desperately grabs onto any supposed “prevention or cure” in fear of the virus. People have started to forgo clinically approved treatments and preventive measures in favor of the false remedies being spread over the internet. In addition, controversial rumors regarding the origins of the virus and its spread in India have sparked conflict between minority groups leading to severe hate crimes and discrimination. False rumours have also negatively impacted many businesses like the poultry industry resulting in large losses. 
            <br />
            To fight the infodemic and help flatten the curve, our team has produced an A.I powered one-tap solution to combat the rapid spread of misinformation.
            <br />
            <b>Winners of the MIT Covid 19 Challenge: Turning the Tides India</b>
            </Paragraph>
          </LeftColumn>
          <RightColumn>
            <img src={logo} alt="logo" />
          </RightColumn>
        </TwoColumn>
      </Container>
      <DecoratorBlob1 />
    </>
  );
};
